
class HXFormFieldDate extends HXFormField {

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            this.setValue(this.getValue()); //Inhalt pruefen und aufformatieren
            var value = '' + this.getValue();

            //Datum Eingabeformat pruefen
            if (value !== '' && HXFormFieldUtils.getDateTextFormated(value) == null) {
                this.validationPassed = false;
                this.validationMsg = hx.replace(this.formVars.dictFormatMsg, "#name#", this.getLabel());

                //Datum - Pflichtfeld
            } else if (!this.getOptional() && value === '') {
                this.validationPassed = false;
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());

                //Datum Min/Max Range
            } else if (value !== '' && (this.getRangeDateMinText()!=='' || this.getRangeDateMaxText()!=='')) {
                var minDate = hx.text2date(this.getRangeDateMinText()); //text2date() liefert null wenn ungueltig
                var maxDate = hx.text2date(this.getRangeDateMaxText()); //text2date() liefert null wenn ungueltig
                var msg = hx.replace(this.formVars.dictDateRangeMinAndMax, "#fieldname#", this.getLabel());
                if (minDate===null) msg = hx.replace(this.formVars.dictDateRangeMax, "#fieldname#", this.getLabel());
                if (maxDate===null) msg = hx.replace(this.formVars.dictDateRangeMin, "#fieldname#", this.getLabel());
                msg = hx.replace(msg, "#von#", this.getRangeDateMinText());
                msg = hx.replace(msg, "#bis#", this.getRangeDateMaxText());

                var inputDate = hx.text2date(this.getValue());
                if ((minDate!==null && inputDate<minDate) || (maxDate!=null && inputDate>maxDate)) {
                    this.validationPassed = false;
                    this.validationMsg = msg;
                }
            }

            if (alertResult===true) {
                super._validateFieldAlert();
            }
        }
        return this.validationPassed;
    }

    /**
     * Setzt Text ins Datumsfeld, wird autom. ins korrekte Format aufformatiert
     * @param {string} dateText z.B. '15.03.2023'
     */
    setValue(dateText) {
        var formated = HXFormFieldUtils.getDateTextFormated(dateText);
        if (formated!==null) dateText = formated;
        super.setValue(dateText);
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional);
    }

    /**
     * @param {string} minDate z.B. '01.01.2023', leerstring = keine grenze
     */
    setRangeDateMinText(minDate) {
        if (minDate===null) minDate = '';
        var dateStr = HXFormFieldUtils.getDateTextFormated(minDate);
        this.inputObj.setAttribute('data-hx-rangemin-date',dateStr);
    }

    /**
     * @param {string} maxDate z.B. '01.01.2023', leerstring = keine grenze
     */
    setRangeDateMaxText(maxDate) {
        if (maxDate===null) maxDate = '';
        var dateStr = HXFormFieldUtils.getDateTextFormated(maxDate);
        this.inputObj.setAttribute('data-hx-rangemax-date',dateStr);
    }

    /**
     * @return {string}
     */
    getRangeDateMinText() {
        return this.inputObj.getAttribute('data-hx-rangemin-date');
    }


    /**
     @return {string}
     */
    getRangeDateMaxText() {
        return this.inputObj.getAttribute('data-hx-rangemax-date');
    }

    /**
     * @param {string} position, DATE_PICKER_POSITION_STANDARD, DATE_PICKER_POSITION_ABOVE
     */
    setDatePickerPosition(position = "under") {
        if (position!=="under") position="above";
        this.inputObj.setAttribute('data-hx-datepicker-pos',position);
    }

    /**
     * @return {string}, above | under
     */
    getDatePickerPosition() {
        return this.inputObj.getAttribute('data-hx-datepicker-pos');
    }




    /**
     * Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true && this.getEditable()) {
            //Datum Tastendruck
            this.inputObj.addEventListener("keydown", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                var result = HXFormFieldUtils.getDateTextKeyEventResult(this.getValue(), event);
                if (result.dateText!==null) {
                    this.setValue(result.dateText);
                    this.getFieldObj().dispatchEvent(new Event('change'));  // Event change ausloesen
                }
                if (result.allowKey===false) event.preventDefault(); //Erscheinen ungueltiger Zeichen im Feld verhindern
                return result.allowKey;
            });
            //Datum Feld verlassen
            this.inputObj.addEventListener("blur", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                this.setValue(this.getValue()); //Inhalt pruefen und aufformatieren
            });

            //Kalender Icon anklicken
            document.getElementById(this.inputName+'_calendaricon').addEventListener("click", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                HXFormFieldDatePicker.init(this.inputName,this.formName,this.formVars,this.getFormFieldTypeName());
            });

            //Kalender Icon Tastendruck (Space oeffnet/schliesst Kalender)
            document.getElementById(this.inputName+'_calendaricon').addEventListener("keypress", (event) => {
                if (event.key===" ") {
                    HXFormFieldDatePicker.init(this.inputName,this.formName,this.formVars,this.getFormFieldTypeName());
                    event.preventDefault();
                    return false;
                }
            });
        }
    }
}